/** Default asset map pin (Jerusalem) until geo fields are exposed in the UI. */
export const DEFAULT_ASSET_LATITUDE = 31.7683;
export const DEFAULT_ASSET_LONGITUDE = 35.2137;
